module.exports = __webpack_public_path__ + "0ee7962b3727f4643e99f639df09fbb1.pdf";